var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-quarter has-text-centered pointer",on:{"click":function($event){return _vm.signUp()}}},[_c('i',{staticClass:"fas fa-arrow-left fa-2x sky-blue-text"})])}
var staticRenderFns = []

export { render, staticRenderFns }